(function () {
  var body = document.body;
  if (body.dataset.muihaBgShift !== 'true') return;

  var pages    = body.dataset.muihaBgPages || 'all';
  var template = body.dataset.template || '';
  if (pages === 'home'    && template !== 'index')   return;
  if (pages === 'product' && template !== 'product') return;

  var hexToRgb = function (hex) {
    return {
      r: parseInt(hex.slice(1, 3), 16),
      g: parseInt(hex.slice(3, 5), 16),
      b: parseInt(hex.slice(5, 7), 16)
    };
  };

  var startColor = hexToRgb(body.dataset.muihaBgStart || '#FAFAF5');
  var endColor   = hexToRgb(body.dataset.muihaBgEnd   || '#EDE5D8');
  var depth      = (parseInt(body.dataset.muihaBgDepth, 10) || 70) / 100;
  var lerp       = function (a, b, t) { return Math.round(a + (b - a) * t); };

  var maxScroll = 0, ticking = false;
  var recalcMax = function () {
    maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  };
  recalcMax();
  window.addEventListener('resize', recalcMax, { passive: true });

  var update = function () {
    var progress = Math.min(window.scrollY / (maxScroll * depth), 1);
    body.style.backgroundColor =
      'rgb(' +
        lerp(startColor.r, endColor.r, progress) + ',' +
        lerp(startColor.g, endColor.g, progress) + ',' +
        lerp(startColor.b, endColor.b, progress) +
      ')';
    ticking = false;
  };

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  document.addEventListener('shopify:section:load',    function () { recalcMax(); update(); });
  document.addEventListener('shopify:section:reorder', function () { recalcMax(); update(); });

  update();
})();
